import { Injectable, NgZone } from '@angular/core';
import * as SockJS from 'sockjs-client';
import { Client, IMessage, Message } from '@stomp/stompjs';
import { Subject } from 'rxjs';
import { AuthService } from './auth-service/authService';
import { EnumDataService } from './services/enum-data.service';


@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  private stompClient: Client;
  private notificationSubject = new Subject<string>();


  private socketUrl = 'https://apis.ifanow.com/futurewise/ws-call'; // Backend STOMP endpoint
  // private socketUrl = 'https://staging.ifanow.in/futurewise/ws-call';
  rmId: any;
  exotalCallData = { advisorId: null, advisorName: null, campaign: null, number: null, email: null, scheduleDescription: null };
  storeUniqueId: any = 0;

  constructor(private auth: AuthService, private enumDataService: EnumDataService, private ngZone: NgZone) {
    this.auth.logout$.subscribe(() => {
      console.log("Calling for disconnection")
      this.disconnect();
    })





  }

  connect() {
    console.log("WEB SOCKET $$$$$$$$$$%%%%%%%%%%%%5$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$")
    // this.enumDataService.setAdvisorPopupValue(true);  // Notify AppComponent

    // this.enumDataService.setExotelNumber(this.exotalCallData);

    this.stompClient = new Client({
      webSocketFactory: () => new SockJS(this.socketUrl),
      debug: (msg) => console.log('[STOMP DEBUG]', msg),
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
      onConnect: () => {
        console.log('..............WebSocket connectedddddddddddddddddddddd..............');

        this.stompClient.subscribe('/topic/call-status', (message: IMessage) => {
          if (message.body) {
            console.log(message)
            const bodyData = JSON.parse(message.body);
            this.rmId = AuthService.getRmId();
            console.log(this.rmId)

            // Now you can access fields like:
            if (!this.enumDataService.PRODUCTION) {
              console.log(bodyData.advisorId, "CALL ADVISOR ID");           // "CALL_UPDATE"
              console.log(bodyData.rmStatus, "CALL RM STAATUS");
              console.log(bodyData.rmPopup, "RM POPUP STATUS");
              console.log(bodyData.advisorPopup, "ADVISOR POPUP STATUS");
              console.log(bodyData.advisorEmail, "RM EMAILID TO SHOW ");                 // true
              console.log(bodyData.advisorStatus, "CALL ADVISOR STATUS");  // "02248962728"
              console.log(bodyData.exotelNumber, " CALL EXOTAL NUMBER");
              console.log(bodyData.callUniqueId, "UNIQUE ID FOR CALL");
              console.log(bodyData.scheduleDescription, "DESCRIPTION ID FOR CALL")
            }




            this.exotalCallData = { advisorId: bodyData.advisorId, advisorName: bodyData.advisorName, campaign: bodyData.couponDescription, number: bodyData.exotelNumber, email: bodyData.advisorEmail, scheduleDescription: bodyData.scheduleDescription }

            console.log('..............WebSocket RESPONSEEEEEEEEEEEEEEEEEEEEE..............');

            if (bodyData.rmId == this.rmId) {

              this.storeUniqueId = bodyData.callUniqueId
              console.log(this.storeUniqueId, "stored unique id");

            }

            if (bodyData.popUp == true && bodyData.rmId == this.rmId && this.storeUniqueId == bodyData.callUniqueId) {
              console.log("DONT SHOW ANY POPUP");
              this.ngZone.run(() => {
                this.enumDataService.setAdvisorPopupValue(false);  // Notify AppComponent
              });


            }
            else {
              if (bodyData.rmStatus == true && bodyData.advisorStatus == false && this.rmId == bodyData.rmId && bodyData.rmPopup == false && bodyData.advisorPopup == false) {
                console.log("BOTH TRUE SHOW rm side popup ")
                this.ngZone.run(() => {
                  this.enumDataService.setAdvisorPopupValue(true);  // Notify AppComponent
                });
                this.enumDataService.setExotelNumber(this.exotalCallData);
                if (bodyData.scheduleDescription) {
                  console.log("DEscription  ");

                  this.enumDataService.setExotelDescription(this.exotalCallData);
                }
                else {
                  this.enumDataService.setExotelDescription(null);
                }


              }
              // else if (bodyData.rmStatus == true && bodyData.advisorStatus == false && this.rmId == bodyData.rmId && bodyData.rmPopup == true && bodyData.advisorPopup == false) {
              //   console.log("DONT SHOW rm side popup ")
              //   this.enumDataService.setAdvisorPopupValue(false);  // Notify AppComponent
              // }

            }



          }
        });
      },
      onStompError: (frame) => {
        console.error('STOMP error:', frame.headers['message'], frame.body);
      }
    });

    this.stompClient.activate();
  }

  getNotifications() {
    return this.notificationSubject.asObservable();
  }

  disconnect() {
    if (this.stompClient && this.stompClient.active) {
      this.stompClient.deactivate();
      console.log('WebSocket disconnected');
    }
  }
}
